import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const LinkedinEmbedder = () => {
  const gdprPreferences = useSelector(
    // @ts-ignore
    (state) => state.gdprPrivacyConsent?.preferences ?? {},
  );

  useEffect(() => {
    const partnerId = '93706';
    const scriptId = 'linkedin-tracker-script';
    const noscriptId = 'linkedin-tracker-noscript';

    // Funzione per rimuovere gli script inseriti
    const removeLinkedinTracker = () => {
      const existingScript = document.getElementById(scriptId);
      const existingNoscript = document.getElementById(noscriptId);
      if (existingScript) existingScript.remove();
      if (existingNoscript) existingNoscript.remove();
      // @ts-ignore
      delete window._linkedin_data_partner_id;
    };

    if (gdprPreferences.prof_LINKEDIN) {
      // Imposta la variabile globale
      // @ts-ignore
      window._linkedin_data_partner_id = partnerId;

      // Evita duplicati
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        script.id = scriptId;
        document.head.appendChild(script);
      }

      if (!document.getElementById(noscriptId)) {
        const noscript = document.createElement('noscript');
        noscript.id = noscriptId;
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none;" alt="" 
          src="https://dc.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif" />
        `;
        document.body.appendChild(noscript);
      }
    } else {
      // Se il consenso viene revocato
      removeLinkedinTracker();
    }

    return () => {
      removeLinkedinTracker();
    };
  }, [gdprPreferences.prof_LINKEDIN]);

  return null;
};

export { LinkedinEmbedder };
